import { Component, Inject, Input } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { ApiService } from 'src/app/shared/services/api.service';
import { SnackbarV3Service } from '@gea/digital-ui-lib';
import { TooltipModule } from 'primeng/tooltip';
import { HrtBookmarkComponent } from 'src/app/shared/components/hrt-bookmark/hrt-bookmark.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HrtDialogComponent } from 'src/app/shared/components/hrt-dialog/hrt-dialog.component';
import { TableResult } from 'src/app/shared/services/api/table';
import { Bookmark } from 'src/app/shared/data/data.generated';

@Component({
  selector: 'bookmark-actions-renderer',
  template: `
    <div class="action-buttons">
      <span (click)="editBookmark(rowData)">
        <mat-icon matSuffix class="ActionIcon" title="Edit"
          ><geaui-icon-v3
            file="16px_edit"
            [colorProp]="'stroke'"
          ></geaui-icon-v3
        ></mat-icon>
      </span>
      <span (click)="deleteBookmark(rowData)">
        <mat-icon matSuffix class="ActionIcon" title="Delete"
          ><geaui-icon-v3
            file="16px_remove"
            [colorProp]="'stroke'"
          ></geaui-icon-v3
        ></mat-icon>
      </span>
    </div>
  `,
  standalone: true,
  imports: [IconV3Component, TooltipModule, MatIconModule],
})
export class BookmarkActionsRenderer {
  constructor(
    private api: ApiService,
    public dialog: MatDialog,
  ) {}
  @Input() rowData: any;
  @Input() config: {
    refreshBookmarksTable: (data: TableResult<Bookmark>) => void;
  };
  downloading: boolean = false;

  @Inject(SnackbarV3Service) private snackbar: SnackbarV3Service;
  
  editBookmark(rowData: any) {
    const dialogRef = this.dialog.open(HrtBookmarkComponent, {
      data: { url: rowData.URL, bookmarkName: rowData.BookmarkName },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        rowData.BookmarkName = result;
        this.api.Bookmark.EditBookmark(
          rowData.ForeignKey,
          rowData.BookmarkType,
          rowData.BookmarkName,
        ).subscribe({
          next: (x) => {
            if (this.config.refreshBookmarksTable) {
              this.config.refreshBookmarksTable(x);
            }
          },
          error: (err) => {
            console.error('Error editing bookmark:', err);
            this.snackbar.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error editing bookmark: ' + err,
            });
          },
        });
      }
    });
  }

  deleteBookmark(rowData: any) {
    const dialogRef = this.dialog.open(HrtDialogComponent, {
      data: {
        title: 'Delete Bookmark',
        msg: 'Are you sure want to permanently delete this bookmark?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.api.Bookmark.DeleteBookmark(
          rowData.ForeignKey,
          rowData.BookmarkType,
        ).subscribe({
          next: (x) => {
            if (this.config.refreshBookmarksTable) {
              this.config.refreshBookmarksTable(x);
            }
          },
          error: (err) => {
            console.error('Error deleting bookmark:', err);
            this.snackbar.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error deleting bookmark: ' + err,
            });
          },
        });
        let existingBookmarks = JSON.parse(
          sessionStorage.getItem('UserBookmarks') || '',
        );
        existingBookmarks = existingBookmarks.filter(
          (bookmark: { ForeignKey: number; BookmarkType: string }) =>
            !(
              bookmark.ForeignKey === rowData.ForeignKey &&
              bookmark.BookmarkType === rowData.BookmarkType
            ),
        );
        sessionStorage.setItem(
          'UserBookmarks',
          JSON.stringify(existingBookmarks),
        );
      }
    });
  }
}
